import React, { useEffect, useState } from 'react'
import useCordinates from '../../../hooks/useCordinates'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/FormikControl/FormikControl';
import useSystemMasterList from '../../../hooks/useSystemMasterList';
import ComplaintImageCapture from './ComplaintImageCapture';
import AddressInputComponent from './AddressInputComponent';
import { useAlert } from '../../../context/AlertContext';
import portalServices from '../portalServices';
import { CircularProgress, Fade } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Add } from '@mui/icons-material';





function ComplaintForm({masters}) {
    const {AppAlert} = useAlert();
    const navigate = useNavigate();
    const [showForm ,setShowForm] = useState(false);
    
    const [imageFile,setImageFile] = useState(null);
    const [lat,setLat] = useState(null);
    const [lng,setLng] = useState(null);
    const [address,setAddress] = useState(null);
    const [addressHelper,setAddressHelper] = useState(null);

    const [saving,setSavingStatus] = useState(false);

    const initialValues = {
        complainantName	:'',
        phone:'',
        email:'',
        details:'',
        grievanceType:''
    }

    const validationRule = Yup.object({
        complainantName	: Yup.string().required("Required"),
        phone:Yup.string().required("Required").matches(/^[0-9]+$/, "Invalid Phone Number").min(10, 'Invalid Phone Number').max(10, 'Invalid Phone Number'),
        details: Yup.string().required("Required"),
        grievanceType: Yup.string().required("Required"),
    });


    const handleImageInput = (file) =>{
        setImageFile(file)
    }

    const onSubmit = (values) =>{
        if(address === null){
            AppAlert("Please Provide Comlaint Address","error");
            return false;
        }

        if(addressHelper === null || addressHelper == ""){
            AppAlert("Please Provide Comlaint Address","error");
            return false;
        }

        if(imageFile == null){
            AppAlert("Complaint Image is Required","error");
            return false;
        }

        values.latitude = lat;
        values.longitude = lng;
        values.address= address;
        values.addressHelper = addressHelper;
        values.imageFile = imageFile;
        setSavingStatus(true);
        portalServices.submitComplaint(values).then(res=>{
            console.log(res)
            AppAlert("Your Complaint Registered Successfully")
            sessionStorage.setItem("customerPhoneNo",values.phone)
            //navigate("/portal/complaint/list")
            //window.location.reload();
        }).catch(error=>{
            console.log(error)
            AppAlert("Someting Went wrong! Try Again","error")
        }).finally(()=>{
            setSavingStatus(false);
        })

    }

    return (
        <>
            {!showForm  &&
            <div className='card'>
                <div className='card-body'>
                    <div className='text-center'>
                        <h5 type="button" onClick={()=>setShowForm(true)} > <Add /> Create New Complain</h5>
                    </div>
                </div>
            </div>
            }
            
            {showForm  &&
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => 
                            <Form>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-6 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Your Name" name="complainantName" 
                                                />
                                            </div>
                                        
                                            <div className='col-md-6 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Phone No." name="phone" 
                                                />
                                            </div>
                                            {/*
                                            <div className='col-md-6 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Email" name="Email" 
                                                />
                                            </div>
                                            */}
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <h5>Complaint Details</h5>
                                            </div>
                                            <div className='col-md-12 mb-3'>
                                                {masters && 
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Complaint About" name="grievanceType"  
                                                        options={masters['grievance-type']} multiple={false} 
                                                    />
                                                }
                                            </div>
                                            

                                            <div className='col-md-12 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Your Complaint" name="details" 
                                                    multiline rows={4}
                                                />
                                            </div>

                                            <div className='col-md-12 mb-3'>
                                                <h6>Complaint Photo</h6>
                                                <ComplaintImageCapture callback={handleImageInput} />
                                            </div>

                                            <div className="col-md-12">
                                                <h5>Complaint Address</h5>
                                                <AddressInputComponent
                                                    lat={lat}
                                                    lng={lng}
                                                    setLat={setLat}
                                                    setLng={setLng}
                                                    address={address}
                                                    setAddress={setAddress}
                                                    addressHelper={addressHelper}
                                                    setAddressHelper={setAddressHelper}
                                                />
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className='card-footer'>
                                        {saving && 
                                            <div className='text-center'>
                                                Submiting your complaint please wait... 
                                                <span className=''><CircularProgress/></span>
                                            </div>
                                        }
                                        {!saving &&
                                            <button   disabled={!formik.isValid}  className='btn btn-lg btn-success float-end' type='submit' > Book My Complaint </button>
                                        }
                                        
                                    </div>
                                </div>
                            </Form>
                    }
                </Formik>
            }
        </>
    )
}

export default ComplaintForm